import SectionSkeleton from "../../../components/ui/SectionSkeleton"
import { Box, Container, Link, Stack, Typography } from "@mui/material"
import { Link as NavLink } from "react-router-dom"
import { Fragment, lazy, Suspense } from "react"
import Images from "../../../assets/js/Images"
import { obj1, obj2, obj3, obj4, obj5, obj6 } from "./data"

const TopBannerA = lazy(() => import("../../../components/common/TopBannerA"))

function RefundPolicy() {
  const sections = [obj1, obj2, obj3, obj4, obj5, obj6]

  return (
    <Fragment>
      <Suspense fallback={<SectionSkeleton />}>
        <TopBannerA
          heading="Refund Policy"
          currentPage="Refund Policy"
          bannerImg={Images?.privacyPolicy}
        />
      </Suspense>

      <Box sx={{ py: 6 }}>
        <Container maxWidth={false} fixed>
          <Stack sx={{ maxWidth: "1100px", mx: "auto" }} spacing={4}>
            <Box>
              <Typography
                mb={2}
                fontSize={28}
                fontWeight="700"
                color="other.color1"
              >Refund Policy for InnerPal.com
              </Typography>
              <Typography
                mb={3}
                fontWeight="500"
                color="other.color1"
              ><b>Effective Date: </b>07/31/2026
              </Typography>
              <Typography
                fontSize={18}
                color="other.color1"
              >InnerPal.com ("we," "us," "our") is dedicated to offering high-quality emotional wellness services. This Refund Policy details the terms for cancellations, rescheduling, no-shows, and refunds across all sessions, appointments, and subscriptions on our platform.
              </Typography>
            </Box>

            {sections.map((obj, i) => (
              <Box key={i}>
                <Typography
                  mb={2}
                  fontSize={24}
                  component="h4"
                  fontWeight="700"
                  color="other.color1"
                >{obj?.title}
                </Typography>
                <Typography
                  mb={2}
                  fontWeight="500"
                  color="other.color1"
                >{obj?.subTitle}
                </Typography>
                {obj?.list && (
                  <Box component="ul">
                    {obj.list.map((item, j) => (
                      <Typography
                        mb={1}
                        key={j}
                        component="li"
                        color="other.color2"
                      >
                        {item?.key && (
                          <>
                            <strong>{item?.key}</strong><br />
                          </>
                        )}
                        {item?.summary}
                      </Typography>
                    ))}
                  </Box>
                )}
              </Box>
            ))}

            <Box>
              <Typography
                mb={2}
                fontSize={24}
                component="h4"
                fontWeight="700"
                color="other.color1"
              >7. Contact Us
              </Typography>
              <Typography
                color="other.color2"
              >If you have any questions or require assistance regarding cancellations or refunds, please contact us:
              </Typography>
              <Typography
                mt={1}
                fontSize={20}
                fontWeight="600"
                color="other.color1"
              >InnerPal.com
              </Typography>
              <Typography
                color="other.color1"
              ><strong>Email:</strong> <Link
                target="_blank"
                fontWeight="500"
                component={NavLink}
                to="mailto:support@innerpal.com"
              >support@innerpal.com
                </Link>
              </Typography>
            </Box>
          </Stack>
        </Container>
      </Box>
    </Fragment>
  )
}

export default RefundPolicy
